module.exports = __webpack_public_path__ + "img/max-file-check--csv.e67a49f3.svg";